export default __webpack_public_path__ + "static/media/click-icon.de4fed02.svg";